import { AnalyticsConnector } from '@amplitude/analytics-connector';
import { Defaults } from './types/config';
import { ExperimentClient } from './experimentClient';
import { ConnectorExposureTrackingProvider, ConnectorUserProvider } from './integration/connector';
import { DefaultUserProvider } from './integration/default';
const instances = {};
/**
 * Initializes a singleton {@link ExperimentClient} identified by the configured
 * instance name.
 *
 * @param apiKey The deployment API Key
 * @param config See {@link ExperimentConfig} for config options
 */

const initialize = (apiKey, config) => {
  var _config;

  // Store instances by appending the instance name and api key. Allows for
  // initializing multiple default instances for different api keys.
  const instanceName = ((_config = config) === null || _config === void 0 ? void 0 : _config.instanceName) || Defaults.instanceName;
  const instanceKey = `${instanceName}.${apiKey}`;

  if (!instances[instanceKey]) {
    config = {
      userProvider: new DefaultUserProvider(),
      ...config
    };
    instances[instanceKey] = new ExperimentClient(apiKey, config);
  }

  return instances[instanceKey];
};
/**
 * Initialize a singleton {@link ExperimentClient} which automatically
 * integrates with the installed and initialized instance of the amplitude
 * analytics SDK.
 *
 * You must be using amplitude-js SDK version 8.17.0+ for this integration to
 * work.
 *
 * @param apiKey The deployment API Key
 * @param config See {@link ExperimentConfig} for config options
 */


const initializeWithAmplitudeAnalytics = (apiKey, config) => {
  var _config2;

  // Store instances by appending the instance name and api key. Allows for
  // initializing multiple default instances for different api keys.
  const instanceName = ((_config2 = config) === null || _config2 === void 0 ? void 0 : _config2.instanceName) || Defaults.instanceName;
  const instanceKey = `${instanceName}.${apiKey}`;
  const connector = AnalyticsConnector.getInstance(instanceName);

  if (!instances[instanceKey]) {
    config = {
      userProvider: new ConnectorUserProvider(connector.identityStore),
      exposureTrackingProvider: new ConnectorExposureTrackingProvider(connector.eventBridge),
      ...config
    };
    instances[instanceKey] = new ExperimentClient(apiKey, config);

    if (config.automaticFetchOnAmplitudeIdentityChange) {
      connector.identityStore.addIdentityListener(() => {
        instances[instanceKey].fetch();
      });
    }
  }

  return instances[instanceKey];
};
/**
 * Provides factory methods for storing singleton instances of {@link ExperimentClient}
 * @category Core Usage
 */


export const Experiment = {
  initialize,
  initializeWithAmplitudeAnalytics
};
//# sourceMappingURL=factory.js.map